import React from 'react';
import { Navigate } from 'react-router-dom';

interface PrivateRouteProps {
  element: JSX.Element;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ element }) => {
  const isAuthenticated = localStorage.getItem('isAuthenticated'); // ログイン状態を確認

  // ログインしていない場合、ログインページにリダイレクト
  return isAuthenticated ? element : <Navigate to="/" />;
};

export default PrivateRoute;
